// extracted by mini-css-extract-plugin
export default {"controls":"ModalCancelSession_controls__BqaC1","button":"ModalCancelSession_button__ReXuQ"};